import React from 'react';

import { useIntl } from 'react-intl-next';

import { Tab, TabList } from '@atlaskit/tabs';

import { messages } from './messages';

type DebuggerTabListProps = {
	isNaturalLanguageQuery: boolean;
	hasMinionOutputs: boolean;
};

export const DebuggerTabList = ({
	isNaturalLanguageQuery,
	hasMinionOutputs,
}: DebuggerTabListProps) => {
	const { formatMessage } = useIntl();

	return (
		<TabList>
			<Tab>{formatMessage(messages.ai_debugger_modal_tab_request_overview)}</Tab>
			{isNaturalLanguageQuery && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_raw_search_results)}</Tab>
			)}
			{isNaturalLanguageQuery && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_ranked_search_results)}</Tab>
			)}
			{isNaturalLanguageQuery && !hasMinionOutputs && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_plugin_invocations)}</Tab>
			)}
			{isNaturalLanguageQuery && hasMinionOutputs && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_minions_invoked)}</Tab>
			)}
			{isNaturalLanguageQuery && (
				<Tab>{formatMessage(messages.ai_debugger_modal_tab_raw_json)}</Tab>
			)}
		</TabList>
	);
};
